import type React from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

type InfoPanelProps = { icon: IconComponent; text: string | JSX.Element | JSX.Element[] };
export const InfoPanel: React.FC<InfoPanelProps> = ({ icon, text }) => {
	return (
		<Box sx={{ backgroundColor: 'sunrise.semantic.background.base' }}>
			<Box sx={{ borderRadius: 'big', bg: 'sunrise.semantic.background.raised', display: 'flex' }} p="sunrise.10">
				<Icon icon={icon} size="xxl" sx={{ marginRight: 'sunrise.4' }} />
				<Text>{text}</Text>
			</Box>
		</Box>
	);
};
